/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';


const ArtistsCloud = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'ArtistsCloud',
    event: '',

  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);


  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const inputHandler = (e) => {
    const { value, name } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value,
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  return (
    <>
      <div>the cloud</div>
      <div className="w-full bg-greyFilter pl-5 rounded-lg flex flex-row pl-9 pb-6px">
        <label className="flex flex-col font-americaMonoRegular  text-xs mt-1 uppercase text-black w-full px-8" htmlFor="event">
          Event Slug (ensure correct typing)
          <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 p-2" onChange={inputHandler} name="event" type="text" value={state.event || ''} readOnly={reusableComponent && reusableComponent} />
        </label>
      </div>

    </>
  );
};

ArtistsCloud.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
};
ArtistsCloud.defaultProps = {
  reusableComponent: null,
};

export default ArtistsCloud;
